<template>
    <div class="container-fluid">
        <!-- Small boxes (Stat box) -->
        <div class="row">
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box orangebgcolor">
              <div class="inner">
                <h3>{{this.CoutnData.total_Banks}}</h3>

                <p>Banks</p>
              </div>
              <div class="icon">
                <i class="ion ion-bag"></i>
              </div>
              <!--   -->
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box yellowbgcolor">
              <div class="inner">
                <h3>{{this.CoutnData.total_Bank_Branch}}</h3>

                <p>Branches</p>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
              <!--   -->
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box tealbgcolor">
              <div class="inner">
                <h3>{{this.CoutnData.total_Clients}}</h3>

                <p>Applicants</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!--   -->
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box purplebgcolor">
              <div class="inner">
                <h3>{{this.CoutnData.total_Products}}</h3>

                <p>Products</p>
              </div>
              <div class="icon">
                <i class="ion ion-pie-graph"></i>
              </div>
              <!--   -->
            </div>
          </div>
          <!-- ./col -->
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box bg-dark">
              <div class="inner">
                <h3>{{this.CoutnData.total_Employess}}</h3>

                <p>Executive</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!--   -->
            </div>
          </div>
          <!-- ./col -->
          <div class="col-lg-3 col-6">
            <!-- small box -->
            <div class="small-box violetbgcolor">
              <div class="inner">
                <h3>{{this.CoutnData.total_Admin}}</h3>

                <p>Admin</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!--   -->
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import ToastTemplet from "../components/widget/toast.vue";
    export default {
        components: { ToastTemplet },
        data() {
            return {
                toast: new Vue(),
                CoutnData:[],
            };
        },
        mounted() {
            this.DashboardData()
        },
        methods:{
            DashboardData(){
                axios.get('DashboardCount')
                .then(({data})=> {this.CoutnData = data[0]})
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            }
        }
    }
</script>
